export enum UserLevel {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  MANAGER = "MANAGER",
  USER = "USER",
  VIEWER = "VIEWER"
}

export enum AccessType {
  // Módulo de Produção
  PRODUCTION_VIEW = "production_view",
  PRODUCTION_CREATE = "production_create",
  PRODUCTION_EDIT = "production_edit",
  PRODUCTION_DELETE = "production_delete",
  
  // Produção - Planejamento
  PRODUCTION_PLANNING_VIEW = "production_planning_view",
  PRODUCTION_PLANNING_CREATE = "production_planning_create",
  PRODUCTION_PLANNING_EDIT = "production_planning_edit",
  PRODUCTION_PLANNING_DELETE = "production_planning_delete",
  
  // Produção - Controle
  PRODUCTION_CONTROL_VIEW = "production_control_view",
  PRODUCTION_CONTROL_CREATE = "production_control_create",
  PRODUCTION_CONTROL_EDIT = "production_control_edit",
  PRODUCTION_CONTROL_DELETE = "production_control_delete",
  
  // Produção - Relatórios
  PRODUCTION_REPORTS_VIEW = "production_reports_view",
  PRODUCTION_REPORTS_CREATE = "production_reports_create",
  PRODUCTION_REPORTS_EDIT = "production_reports_edit",
  PRODUCTION_REPORTS_DELETE = "production_reports_delete",
  
  // Módulo de Usuários
  USERS_VIEW = "users_view",
  USERS_CREATE = "users_create",
  USERS_EDIT = "users_edit",
  USERS_DELETE = "users_delete",
  
  // Módulo de Administração
  ADMIN_USERS = "admin_users",
  ADMIN_ROLES = "admin_roles",
  ADMIN_SYSTEM = "admin_system",
  ADMIN_LOGS = "admin_logs",
  ADMIN_COMPANIES = "admin_companies",
  ADMIN_SETTINGS = "admin_settings",
  
  // Módulo de Configurações
  SETTINGS_VIEW = "settings_view",
  SETTINGS_EDIT = "settings_edit",
  
  // Acessos específicos da Sidebar
  SIDEBAR_PRODUCTION = "sidebar_production",
  SIDEBAR_PRODUCTION_PLANNING = "sidebar_production_planning",
  SIDEBAR_PRODUCTION_PLANNING_PANEL = "sidebar_production_planning_panel",
  // Capacidades do Mestti OPS
  CONSULTORIA_CHAT_INTERNAL = "consultoria_chat_internal",
  CONSULTORIA_ACTIONS_VIEW = "consultoria_actions_view",
  CONSULTORIA_ACTIONS_APPROVE = "consultoria_actions_approve",
  CONSULTORIA_ACTIONS_MUTATE = "consultoria_actions_mutate",
  SIDEBAR_PRODUCTION_SCHEDULE = "sidebar_production_schedule",
  SIDEBAR_PRODUCTION_RESOURCES = "sidebar_production_resources",
  SIDEBAR_PRODUCTION_APONTAMENTO = "sidebar_production_apontamento",
  SIDEBAR_PRODUCTION_CONTROL = "sidebar_production_control",
  SIDEBAR_PRODUCTION_CONTROL_AUDIT = "sidebar_production_control_audit",
  SIDEBAR_PRODUCTION_CONTROL_NC = "sidebar_production_control_nc",
  SIDEBAR_PRODUCTION_CONTROL_LOTES = "sidebar_production_control_lotes",
  SIDEBAR_PRODUCTION_MONITORING = "sidebar_production_monitoring",
  SIDEBAR_PRODUCTION_FACTORY_VIEW = "sidebar_production_factory_view",
  SIDEBAR_PRODUCTION_DASHBOARDS = "sidebar_production_dashboards",
  SIDEBAR_PRODUCTION_MELHORIA = "sidebar_production_melhoria",
  SIDEBAR_PRODUCTION_REPORTS = "sidebar_production_reports",
  SIDEBAR_PRODUCTION_PARAMETRIZACAO = "sidebar_production_parametrizacao",
  SIDEBAR_PRODUCTION_SETORES = "sidebar_production_setores",
  SIDEBAR_PRODUCTION_MAQUINAS = "sidebar_production_maquinas",
  SIDEBAR_PRODUCTION_CATEGORIAS = "sidebar_production_categorias",
  SIDEBAR_PRODUCTION_CAUSAS = "sidebar_production_causas",
  SIDEBAR_PRODUCTION_PROCESSOS = "sidebar_production_processos",
  SIDEBAR_PRODUCT_ENGINEERING = "sidebar_product_engineering",
  SIDEBAR_PRODUCT_ENGINEERING_PRODUCT = "sidebar_product_engineering_product",
  SIDEBAR_PRODUCT_ENGINEERING_COMPONENTES = "sidebar_product_engineering_componentes",
  SIDEBAR_PRODUCT_ENGINEERING_PROCESSO = "sidebar_product_engineering_processo",
  
  // Sidebar - Dashboard
  SIDEBAR_DASHBOARD = "sidebar_dashboard",

  // Sidebar - Administração
  SIDEBAR_ADMIN_PANEL = "sidebar_admin_panel",
  SIDEBAR_SENSORES = "sidebar_sensores",
  
  // Sidebar - Sensoriamento
  SIDEBAR_SENSORIAMENTO = "sidebar_sensoriamento",
  SIDEBAR_SENSORIAMENTO_SENSORES = "sidebar_sensoriamento_sensores",
  SIDEBAR_SENSORIAMENTO_RELATORIOS = "sidebar_sensoriamento_relatorios",
  
  // Sidebar - Configurações
  SIDEBAR_SETTINGS = "sidebar_settings",
  
  // Sidebar - Qualidade
  SIDEBAR_QUALITY = "sidebar_quality",
  SIDEBAR_QUALITY_PARAMETROS = "sidebar_quality_parametros",
  SIDEBAR_QUALITY_CHECKLIST = "sidebar_quality_checklist",
  SIDEBAR_QUALITY_REGRAS = "sidebar_quality_regras",
  SIDEBAR_QUALITY_AUDITORIA = "sidebar_quality_auditoria",
  SIDEBAR_QUALITY_DASHBOARDS = "sidebar_quality_dashboards",
  SIDEBAR_QUALITY_PLANEJAMENTO = "sidebar_quality_planejamento",
  SIDEBAR_QUALITY_OPERACAO = "sidebar_quality_operacao",

  // Sidebar - Suprimentos
  SIDEBAR_SUPRIMENTOS = "sidebar_suprimentos",
  SIDEBAR_SUPRIMENTOS_ESTOQUE = "sidebar_suprimentos_estoque",
  SIDEBAR_SUPRIMENTOS_SEPARACOES = "sidebar_suprimentos_separacoes",
  SIDEBAR_SUPRIMENTOS_MOVIMENTACOES = "sidebar_suprimentos_movimentacoes",
  SIDEBAR_SUPRIMENTOS_PARAMETRIZACAO = "sidebar_suprimentos_parametrizacao",
  SIDEBAR_SUPRIMENTOS_NOTAS_FISCAIS = "sidebar_suprimentos_notas_fiscais",

  // Sidebar - Vendas
  SIDEBAR_SALES = "sidebar_sales",
  SIDEBAR_SALES_PDV = "sidebar_sales_pdv",
  SIDEBAR_SALES_PEDIDOS = "sidebar_sales_pedidos",
  SIDEBAR_SALES_TABELA = "sidebar_sales_tabela"
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  user_level: UserLevel;
  is_active: boolean;
  last_login_at?: string;
  created_at: string;
  updated_at: string;
}

export interface UserCreate {
  email: string;
  full_name: string;
  password: string;
  user_level: UserLevel;
  is_active: boolean;
}

export interface UserUpdate {
  email?: string;
  full_name?: string;
  password?: string;
  user_level?: UserLevel;
  is_active?: boolean;
}

/**
 * Acesso ao Mestti OPS decidido pelo backend (padrão do nível + override
 * individual). O frontend só renderiza — nunca recalcula a regra.
 */
export type MesttiOpsAccessSource =
  | 'level_default'
  | 'override_on'
  | 'override_off'
  | 'denied_level'
  | 'inactive';

/** GET /users/me/mestti-ops-access */
export interface MyMesttiOpsAccess {
  enabled: boolean;
  source: MesttiOpsAccessSource;
}

/** GET|PUT /users/{id}/mestti-ops-access */
export interface MesttiOpsAccess extends MyMesttiOpsAccess {
  default_enabled: boolean;
  can_edit: boolean;
}

export interface UserAccess {
  id: string;
  user_id: string;
  access_type: AccessType;
  is_active: boolean;
  granted_by?: string;
  granted_at?: string;
  expires_at?: string;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface UserAccessWithUser extends UserAccess {
  user_email: string;
  user_full_name: string;
  granted_by_email?: string;
  granted_by_full_name?: string;
}

export interface UserAccessCreate {
  user_id: string;
  access_type: AccessType;
  is_active: boolean;
  expires_at?: string;
  notes?: string;
}

export interface UserAccessUpdate {
  access_type?: AccessType;
  is_active?: boolean;
  expires_at?: string;
  notes?: string;
}

export interface BulkAccessCreate {
  user_ids: string[];
  access_types: AccessType[];
  expires_at?: string;
  notes?: string;
}

export interface AccessSummary {
  access_type: AccessType;
  active_count: number;
  total_count: number;
  users_with_access: string[];
}

export interface UserAccessSummary {
  user_id: string;
  user_email: string;
  user_full_name: string;
  user_level: string;
  total_accesses: number;
  active_accesses: number;
  access_types: AccessType[];
  last_granted?: string;
}

// Mapeamento de nomes amigáveis para os tipos de acesso
export const ACCESS_TYPE_LABELS: Record<AccessType, string> = {
  // Produção
  [AccessType.PRODUCTION_VIEW]: "Visualizar Produção",
  [AccessType.PRODUCTION_CREATE]: "Criar Produção",
  [AccessType.PRODUCTION_EDIT]: "Editar Produção",
  [AccessType.PRODUCTION_DELETE]: "Deletar Produção",
  
  // Produção - Planejamento
  [AccessType.PRODUCTION_PLANNING_VIEW]: "Visualizar Planejamento",
  [AccessType.PRODUCTION_PLANNING_CREATE]: "Criar Planejamento",
  [AccessType.PRODUCTION_PLANNING_EDIT]: "Editar Planejamento",
  [AccessType.PRODUCTION_PLANNING_DELETE]: "Deletar Planejamento",
  
  // Produção - Controle
  [AccessType.PRODUCTION_CONTROL_VIEW]: "Visualizar Controle",
  [AccessType.PRODUCTION_CONTROL_CREATE]: "Criar Controle",
  [AccessType.PRODUCTION_CONTROL_EDIT]: "Editar Controle",
  [AccessType.PRODUCTION_CONTROL_DELETE]: "Deletar Controle",
  
  // Produção - Relatórios
  [AccessType.PRODUCTION_REPORTS_VIEW]: "Visualizar Relatórios",
  [AccessType.PRODUCTION_REPORTS_CREATE]: "Criar Relatórios",
  [AccessType.PRODUCTION_REPORTS_EDIT]: "Editar Relatórios",
  [AccessType.PRODUCTION_REPORTS_DELETE]: "Deletar Relatórios",
  
  // Usuários
  [AccessType.USERS_VIEW]: "Visualizar Usuários",
  [AccessType.USERS_CREATE]: "Criar Usuários",
  [AccessType.USERS_EDIT]: "Editar Usuários",
  [AccessType.USERS_DELETE]: "Deletar Usuários",

  // Administração
  [AccessType.ADMIN_USERS]: "Gerenciar Usuários",
  [AccessType.ADMIN_ROLES]: "Gerenciar Roles",
  [AccessType.ADMIN_SYSTEM]: "Configurações do Sistema",
  [AccessType.ADMIN_LOGS]: "Visualizar Logs",
  [AccessType.ADMIN_COMPANIES]: "Gerenciar Empresas",
  [AccessType.ADMIN_SETTINGS]: "Gerenciar Configurações",

  // Configurações
  [AccessType.SETTINGS_VIEW]: "Visualizar Configurações",
  [AccessType.SETTINGS_EDIT]: "Editar Configurações",
  
  // Sidebar - Produção
  [AccessType.SIDEBAR_PRODUCTION]: "Sidebar Produção",
  [AccessType.SIDEBAR_PRODUCTION_PLANNING]: "Sidebar Planejamento",
  [AccessType.SIDEBAR_PRODUCTION_PLANNING_PANEL]: "Sidebar Painel de Planejamento",
  [AccessType.CONSULTORIA_CHAT_INTERNAL]: "Otto (Abrir Chats)",
  [AccessType.CONSULTORIA_ACTIONS_VIEW]: "Otto (Consultar ações)",
  [AccessType.CONSULTORIA_ACTIONS_APPROVE]: "Otto (Aprovar e executar propostas)",
  [AccessType.CONSULTORIA_ACTIONS_MUTATE]: "Otto (Alterar restrições)",
  [AccessType.SIDEBAR_PRODUCTION_SCHEDULE]: "Sidebar Cronograma",
  [AccessType.SIDEBAR_PRODUCTION_RESOURCES]: "Sidebar Recursos",
  [AccessType.SIDEBAR_PRODUCTION_APONTAMENTO]: "Sidebar Apontamento",
  [AccessType.SIDEBAR_PRODUCTION_CONTROL]: "Sidebar Controle",
  [AccessType.SIDEBAR_PRODUCTION_CONTROL_AUDIT]: "Sidebar Auditoria",
  [AccessType.SIDEBAR_PRODUCTION_CONTROL_NC]: "Sidebar Não Conformidades",
  [AccessType.SIDEBAR_PRODUCTION_CONTROL_LOTES]: "Sidebar Lotes",
  [AccessType.SIDEBAR_PRODUCTION_MONITORING]: "Sidebar Monitoramento",
  [AccessType.SIDEBAR_PRODUCTION_FACTORY_VIEW]: "Sidebar Visão da Fábrica",
  [AccessType.SIDEBAR_PRODUCTION_DASHBOARDS]: "Sidebar Dashboards",
  [AccessType.SIDEBAR_PRODUCTION_MELHORIA]: "Sidebar Melhoria",
  [AccessType.SIDEBAR_PRODUCTION_REPORTS]: "Sidebar Relatórios",
  [AccessType.SIDEBAR_PRODUCTION_PARAMETRIZACAO]: "Sidebar Parametrização",
  [AccessType.SIDEBAR_PRODUCTION_SETORES]: "Sidebar Setores",
  [AccessType.SIDEBAR_PRODUCTION_MAQUINAS]: "Sidebar Máquinas",
  [AccessType.SIDEBAR_PRODUCTION_CATEGORIAS]: "Sidebar Categorias",
  [AccessType.SIDEBAR_PRODUCTION_CAUSAS]: "Sidebar Causas",
  [AccessType.SIDEBAR_PRODUCTION_PROCESSOS]: "Sidebar Processos",
  [AccessType.SIDEBAR_PRODUCT_ENGINEERING]: "Engenharia",
  [AccessType.SIDEBAR_PRODUCT_ENGINEERING_PRODUCT]: "Eng. Produto",
  [AccessType.SIDEBAR_PRODUCT_ENGINEERING_COMPONENTES]: "Sidebar Componentes",
  [AccessType.SIDEBAR_PRODUCT_ENGINEERING_PROCESSO]: "Sidebar Processos (Engenharia)",
  
  // Sidebar - Dashboard
  [AccessType.SIDEBAR_DASHBOARD]: "Sidebar Dashboard",

  // Sidebar - Administração
  [AccessType.SIDEBAR_ADMIN_PANEL]: "Sidebar Painel Admin",
  [AccessType.SIDEBAR_SENSORES]: "Sidebar Sensores",
  
  // Sidebar - Sensoriamento
  [AccessType.SIDEBAR_SENSORIAMENTO]: "Sidebar Sensoriamento",
  [AccessType.SIDEBAR_SENSORIAMENTO_SENSORES]: "Sidebar Sensores",
  [AccessType.SIDEBAR_SENSORIAMENTO_RELATORIOS]: "Sidebar Relatórios de Sensoriamento",
  
  // Sidebar - Configurações
  [AccessType.SIDEBAR_SETTINGS]: "Sidebar Configurações",
  
  // Sidebar - Qualidade
  [AccessType.SIDEBAR_QUALITY]: "Sidebar Qualidade",
  [AccessType.SIDEBAR_QUALITY_PARAMETROS]: "Sidebar Parâmetros de Qualidade",
  [AccessType.SIDEBAR_QUALITY_CHECKLIST]: "Sidebar Checklist",
  [AccessType.SIDEBAR_QUALITY_REGRAS]: "Sidebar Regras de Qualidade",
  [AccessType.SIDEBAR_QUALITY_AUDITORIA]: "Sidebar Auditoria de Qualidade",
  [AccessType.SIDEBAR_QUALITY_DASHBOARDS]: "Sidebar Dashboards de Qualidade",
  [AccessType.SIDEBAR_QUALITY_PLANEJAMENTO]: "Sidebar Planejamento de Checklist",
  [AccessType.SIDEBAR_QUALITY_OPERACAO]: "Sidebar Operação de Qualidade",

  // Sidebar - Suprimentos
  [AccessType.SIDEBAR_SUPRIMENTOS]: "Sidebar Suprimentos",
  [AccessType.SIDEBAR_SUPRIMENTOS_ESTOQUE]: "Sidebar Estoque",
  [AccessType.SIDEBAR_SUPRIMENTOS_SEPARACOES]: "Sidebar Separações",
  [AccessType.SIDEBAR_SUPRIMENTOS_MOVIMENTACOES]: "Sidebar Movimentações",
  [AccessType.SIDEBAR_SUPRIMENTOS_PARAMETRIZACAO]: "Sidebar Parametrização",
  [AccessType.SIDEBAR_SUPRIMENTOS_NOTAS_FISCAIS]: "Sidebar Notas Fiscais",

  // Sidebar - Vendas
  [AccessType.SIDEBAR_SALES]: "Sidebar Vendas",
  [AccessType.SIDEBAR_SALES_PDV]: "Sidebar PDV",
  [AccessType.SIDEBAR_SALES_PEDIDOS]: "Sidebar Pedidos",
  [AccessType.SIDEBAR_SALES_TABELA]: "Sidebar Tabela de Vendas"
};

// Mapeamento de nomes amigáveis para os níveis de usuário
export const USER_LEVEL_LABELS: Record<UserLevel, string> = {
  [UserLevel.SUPER_ADMIN]: "Super Administrador",
  [UserLevel.ADMIN]: "Administrador",
  [UserLevel.MANAGER]: "Gerente",
  [UserLevel.USER]: "Usuário",
  [UserLevel.VIEWER]: "Visualizador"
};

// Agrupamento de tipos de acesso por módulo
export const ACCESS_TYPE_GROUPS = {
  production: [
    AccessType.PRODUCTION_VIEW,
    AccessType.PRODUCTION_CREATE,
    AccessType.PRODUCTION_EDIT,
    AccessType.PRODUCTION_DELETE,
    AccessType.PRODUCTION_PLANNING_VIEW,
    AccessType.PRODUCTION_PLANNING_CREATE,
    AccessType.PRODUCTION_PLANNING_EDIT,
    AccessType.PRODUCTION_PLANNING_DELETE,
    AccessType.PRODUCTION_CONTROL_VIEW,
    AccessType.PRODUCTION_CONTROL_CREATE,
    AccessType.PRODUCTION_CONTROL_EDIT,
    AccessType.PRODUCTION_CONTROL_DELETE,
    AccessType.PRODUCTION_REPORTS_VIEW,
    AccessType.PRODUCTION_REPORTS_CREATE,
    AccessType.PRODUCTION_REPORTS_EDIT,
    AccessType.PRODUCTION_REPORTS_DELETE
  ],
  users: [
    AccessType.USERS_VIEW,
    AccessType.USERS_CREATE,
    AccessType.USERS_EDIT,
    AccessType.USERS_DELETE
  ],
  administration: [
    AccessType.ADMIN_USERS,
    AccessType.ADMIN_ROLES,
    AccessType.ADMIN_SYSTEM,
    AccessType.ADMIN_LOGS,
    AccessType.ADMIN_COMPANIES,
    AccessType.ADMIN_SETTINGS
  ],
  settings: [
    AccessType.SETTINGS_VIEW,
    AccessType.SETTINGS_EDIT
  ],
  sidebar: [
    AccessType.SIDEBAR_PRODUCTION,
    AccessType.SIDEBAR_PRODUCTION_PLANNING,
    AccessType.SIDEBAR_PRODUCTION_PLANNING_PANEL,
    AccessType.SIDEBAR_PRODUCTION_SCHEDULE,
    AccessType.SIDEBAR_PRODUCTION_RESOURCES,
    AccessType.SIDEBAR_PRODUCTION_APONTAMENTO,
    AccessType.SIDEBAR_PRODUCTION_CONTROL,
    AccessType.SIDEBAR_PRODUCTION_CONTROL_AUDIT,
    AccessType.SIDEBAR_PRODUCTION_CONTROL_NC,
    AccessType.SIDEBAR_PRODUCTION_CONTROL_LOTES,
    AccessType.SIDEBAR_PRODUCTION_MONITORING,
    AccessType.SIDEBAR_PRODUCTION_FACTORY_VIEW,
    AccessType.SIDEBAR_PRODUCTION_DASHBOARDS,
    AccessType.SIDEBAR_PRODUCTION_MELHORIA,
    AccessType.SIDEBAR_PRODUCTION_REPORTS,
    AccessType.SIDEBAR_PRODUCTION_PARAMETRIZACAO,
    AccessType.SIDEBAR_PRODUCTION_SETORES,
    AccessType.SIDEBAR_PRODUCTION_MAQUINAS,
    AccessType.SIDEBAR_PRODUCTION_CATEGORIAS,
    AccessType.SIDEBAR_PRODUCTION_CAUSAS,
    AccessType.SIDEBAR_PRODUCTION_PROCESSOS,
    AccessType.SIDEBAR_PRODUCT_ENGINEERING,
    AccessType.SIDEBAR_PRODUCT_ENGINEERING_PRODUCT,
    AccessType.SIDEBAR_PRODUCT_ENGINEERING_COMPONENTES,
    AccessType.SIDEBAR_PRODUCT_ENGINEERING_PROCESSO,
    AccessType.SIDEBAR_DASHBOARD,
    AccessType.SIDEBAR_ADMIN_PANEL,
    AccessType.SIDEBAR_SENSORES,
    AccessType.SIDEBAR_SENSORIAMENTO,
    AccessType.SIDEBAR_SENSORIAMENTO_SENSORES,
    AccessType.SIDEBAR_SENSORIAMENTO_RELATORIOS,
    AccessType.SIDEBAR_SETTINGS,
    AccessType.SIDEBAR_QUALITY,
    AccessType.SIDEBAR_QUALITY_PARAMETROS,
    AccessType.SIDEBAR_QUALITY_CHECKLIST,
    AccessType.SIDEBAR_QUALITY_REGRAS,
    AccessType.SIDEBAR_QUALITY_AUDITORIA,
    AccessType.SIDEBAR_QUALITY_DASHBOARDS,
    AccessType.SIDEBAR_QUALITY_PLANEJAMENTO,
    AccessType.SIDEBAR_QUALITY_OPERACAO,
    AccessType.SIDEBAR_SUPRIMENTOS,
    AccessType.SIDEBAR_SUPRIMENTOS_ESTOQUE,
    AccessType.SIDEBAR_SUPRIMENTOS_SEPARACOES,
    AccessType.SIDEBAR_SUPRIMENTOS_MOVIMENTACOES,
    AccessType.SIDEBAR_SUPRIMENTOS_PARAMETRIZACAO,
    AccessType.SIDEBAR_SUPRIMENTOS_NOTAS_FISCAIS,
    AccessType.SIDEBAR_SALES,
    AccessType.SIDEBAR_SALES_PDV,
    AccessType.SIDEBAR_SALES_PEDIDOS,
    AccessType.SIDEBAR_SALES_TABELA
  ]
};

export const ACCESS_TYPE_GROUP_LABELS = {
  production: "Produção",
  users: "Usuários",
  administration: "Administração",
  settings: "Configurações",
  sidebar: "Sidebar"
};
